import React, { FC } from 'react';
import Tooltip from 'HOC/Tooltip';
import Pill from 'Components/Pill';
import injectSheet from 'react-jss';
import { AttributeObject } from '../classes/attributes.classes';
import styleSheet from './styles';

interface Props {
  classes?: any;
  text?: string;
  groupCount?: string;
  attribute?: AttributeObject;
  focusOnHover?: boolean;
}

const GeographyPill: FC<Props> = (props: Props) => {
  const { classes, text, groupCount, attribute, focusOnHover } = props;

  const tooltipDescription = (
    <div className={classes.pillDescription}>
      <div className={classes.pillDescriptionTitle}>
        Inquiries that match
        <span className={classes.strongText}> ANY </span>
        of the following:
      </div>

      <div className={classes.pillDescriptionContainer}>
        <span className={classes.strongText}>USA</span>
        {attribute.attributes.usa.map((toolText: string) => {
          return <div key={toolText}>{`- ${toolText}`}</div>;
        })}
      </div>
      <div className={classes.pillDescriptionContainer}>
        <span className={classes.strongText}>International</span>
        {attribute.attributes.international.map((toolText: string) => {
          return <div key={toolText}>{`- ${toolText}`}</div>;
        })}
      </div>
    </div>
  );

  return (
    <div className={classes.pillContainerHorizontal} key={text}>
      <Tooltip
        position="right"
        offsetTop={-5}
        offsetLeft={112}
        text={tooltipDescription}
        width="250px"
        overrideEvents={{
          showToolTip: ['onMouseEnter', 'onFocus'],
          hideToolTip: ['onBlur', 'onMouseLeave'],
        }}
        parentText="Geographcy"
      >
        <Pill text={text} groupCount={groupCount} focusOnHover={focusOnHover} />
      </Tooltip>
    </div>
  );
};

GeographyPill.defaultProps = {
  classes: {},
  text: '',
  groupCount: '',
  attribute: { label: '', attributes: [], type: 'engagement' },
  focusOnHover: false,
};

export default injectSheet(styleSheet)(GeographyPill);
